import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ApplicationdateService } from "./shared/applicationdate.service";
import { CommonmastersService } from "../../commonmasters/commonmasters.service";
import { Router } from '@angular/router';
import { AuthService } from "../../login/shared/auth.service";
import { formatDate } from "@angular/common";

@Component({
  selector: 'app-changedate',
  templateUrl: './changedate.component.html',
  styleUrls: ['./changedate.component.css']
})
export class ChangedateComponent implements OnInit {

  addForm: FormGroup;
  btnvisibility: boolean = true;
  BranchList: any[] = [];
  ErrorText: string;

  pipe = new DatePipe('en-US');
 

  constructor(private formBuilder: FormBuilder,
    private router: Router,private authService: AuthService,
    private applicationdateService: ApplicationdateService,
    private commonmastersService: CommonmastersService) { }

  ngOnInit() {

    // const format = 'dd/MM/yyyy';
    // const locale = 'en-US';

    this.addForm = this.formBuilder.group({
      frmId: [],
      frmBranchId: [0, Validators.required],
      frmCurrentDate: [],
      // frmCurrentDate: [localStorage.getItem("ApplicationDate")],
      // frmChangeDate: [this.pipe.transform((new Date()), 'dd/MM/yyyy'), Validators.required],
      frmChangeDate: [this.pipe.transform((new Date())), Validators.required],
      frmRemarks: [],
      frmActive: [true],
      frmFlag: [1],
    })

    this.GetBranchList();
  }

  onSubmit() {

    if (this.addForm.value.frmBranchId != 0) {
      this.applicationdateService.IUDApplicationDate(this.addForm).toPromise()
        .then(data => {

        this.authService.logout();
        localStorage.removeItem("EmployeeData");
        localStorage.removeItem("ApplicationDate");
        localStorage.clear();
        this.router.navigate(['/login']);
          
          // const dateFormat = 'dd/MM/yyyy';
          // const ApplicationDate = this.pipe.transform((this.addForm.value.frmChangeDate), dateFormat);
          // localStorage.setItem("ApplicationDate", ApplicationDate);
          // this.router.navigate(['/dashbord']);
        })
      }
  }

  GetBranchList() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
    })
  }

  SelectBranchDate(){
    if (this.addForm.value.frmBranchId != 0) {      

      this.commonmastersService.GetApplicationDate(this.addForm.value.frmBranchId).toPromise()
      .then(data => {
        console.log(data)
        if(data != null){
          const format= 'MMM d, y';
          const locale = 'en-US';
          let branchDate =   new Date(data.ApplicationDate);
          const formattedDate = formatDate(branchDate, format, locale);
        
        this.addForm.controls['frmCurrentDate'].setValue(formattedDate);
        }
        else{

          const format= 'MMM d, y';
          const systemDate = new Date();
          const locale = 'en-US';
          const formattedDate = formatDate(systemDate, format, locale);
          this.addForm.controls['frmCurrentDate'].setValue(formattedDate);
        }
      })
    }
  }



  // resetForm() {
  //   if (this.addForm.value.frmBranchId != 0) {
  //     this.addForm.value.frmActive = false;
  //     this.addForm.value.frmFlag = 2;
  //     this.applicationdateService.IUDApplicationDate(this.addForm).toPromise()
  //       .then(data => {

  //         this.router.navigate(['/dashbord']);
  //       })
  //   }
  // }

  ResetApplicationDate(){
    if (this.addForm.value.frmBranchId != 0) {

      this.addForm.value.frmActive = 0;
      this.addForm.value.frmFlag = 3;

      this.applicationdateService.IUDApplicationDate(this.addForm).toPromise()
        .then(data => {

        this.authService.logout();
        localStorage.removeItem("EmployeeData");
        localStorage.removeItem("ApplicationDate");
        localStorage.clear();
        this.router.navigate(['/login']);
          
          // const dateFormat = 'dd/MM/yyyy';
          // const ApplicationDate = this.pipe.transform((this.addForm.value.frmChangeDate), dateFormat);
          // localStorage.setItem("ApplicationDate", ApplicationDate);
          // this.router.navigate(['/dashbord']);
        })
      }
  }
}

